import axios from 'axios'
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../shared/vars'

export const storesAreLoading = () => {
	return {
		type: 'STORES_ARE_LOADING'
	}
}

export const storeshasError = (err)  => {
	return {
		type: 'STORES_HAS_ERROR',
		error: err
	}
}

export const storesSuccess = (payload)  => {
	return {
		type: 'STORES_SUCCESS',
		payload
	}
}

export const resetStores = ()  => {
	return {
		type: 'RESET_STORES'
	}
}

export function getAllStores(){
	return (dispatch) => {
		dispatch(storesAreLoading())

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY }

		return axios.get(REACT_APP_API_URL + 'store-locations/', { headers: AUTH_HEADER })
		.then((response) => dispatch(storesSuccess(response)))
		.catch((err) => {
			console.log(err)
			console.log('getAllStores error:', err.response.statusText)
			dispatch(storeshasError(err.response.statusText))
		})
	}
}



// WEBPACK FOOTER //
// ./src/store/actions/storeLocation.js